
$(document).ready(function() {	
	
	
	var headlines = $('.to-features h4');
	
	pt_sameHeightHeadlines(headlines);
  
	$(window).on('resize', function(){
		pt_sameHeightHeadlines(headlines);
	});
	
	
	$('a.button').on('click', function(e){
		
		e.preventDefault(); 
		
    if(typeof $(this).data('pt_cta_id') != "undefined" && $(this).data('pt_cta_id') != "") {
      const pt_cta_id = $(this).data('pt_cta_id');
      pSendGAEvent('pt_cta_click', { pt_cta_id: pt_cta_id}, 'mapmarket.js', 'mapmarketalt-cta-'+$(this).data('pt_cta_click')+' send event gone wrong');
    }
    
    if(typeof $(this).data('ctatype') != "undefined" && $(this).data('ctatype') != "") {
      const pt_cta_id = $(this).data('pt_cta_id');
      pSendGAEvent('pt_cta_click', {'pt_cta_id': 'mapmarketalt-cta-'+$(this).data('ctatype'), 'language': $(this).data('language')}, 'mapmarket.js', 'mapmarketalt-cta-'+$(this).data('ctatype')+' send event gone wrong');		      
    }
			
		window.location = $(this).attr('href');        
  });
	
	
	
});

function pt_sameHeightHeadlines(hls) {
	
	var height = 0;
	
	hls.attr('style', '');
	
	hls.each(function(){
		if(height < $(this).height())
			height = $(this).height();
	});
	
	hls.each(function(){
		$(this).height(height);
	});
}

